import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { StyledPlaybookSummaryRow } from "./styles";

type PlaybookSummaryRowProps = {
    label: string;
    dataAutomation: string;
    children: ReactNode;
};

export const PlaybookSummaryRow = ({ label, dataAutomation, children }: PlaybookSummaryRowProps) => (
    <StyledPlaybookSummaryRow
        gap="4px"
        data-automation={dataAutomation}
        padding="12px 14px"
    >
        <Text
            fontVariant="subtitle2"
            color={colorsPalettes.carbon["500"]}
        >
            {label}
        </Text>
        {typeof children === "string" ? (
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon["400"]}
                margin="0 0 4px"
            >
                {children}
            </Text>
        ) : (
            children
        )}
    </StyledPlaybookSummaryRow>
);
